/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  ProgramType,
  ProgramTypeFromJSON,
  ProgramTypeToJSON,
} from './'

/**
 * Object that encapsulates all tuition payment information made to a director or tutor.
 * @export
 * @interface TuitionPaymentInfo
 */
export interface TuitionPaymentInfo {
  /**
   * The unique identifier of the tuition payment.
   * @type {number}
   * @memberof TuitionPaymentInfo
   */
  tuitionPaymentKey: number
  /**
   * The unique identifier of the student whom a payment was made on behalf of.
   * @type {number}
   * @memberof TuitionPaymentInfo
   */
  studentKey: number
  /**
   * The unique identifier of the program the student is enrolled in.
   * @type {number}
   * @memberof TuitionPaymentInfo
   */
  programKey: number
  /**
   * The student's first name.
   * @type {string}
   * @memberof TuitionPaymentInfo
   */
  studentName: string
  /**
   *
   * @type {ProgramType}
   * @memberof TuitionPaymentInfo
   */
  programType: ProgramType
  /**
   * The date the payment was made.
   * @type {Date}
   * @memberof TuitionPaymentInfo
   */
  paymentDate: Date
  /**
   *
   * @type {CashAmount}
   * @memberof TuitionPaymentInfo
   */
  amountPaid: CashAmount
  /**
   * The description of the payment.
   * @type {string}
   * @memberof TuitionPaymentInfo
   */
  description: string
  /**
   * If true, this payment is considered a discount that was applied by the director. A discount is treated the same way as a payment, but should be labeled as 'Discount' within the UI.
   * @type {boolean}
   * @memberof TuitionPaymentInfo
   */
  isDirectorDiscount: boolean
}

export function TuitionPaymentInfoFromJSON(json: any): TuitionPaymentInfo {
  return TuitionPaymentInfoFromJSONTyped(json, false)
}

export function TuitionPaymentInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TuitionPaymentInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    tuitionPaymentKey: json['tuitionPaymentKey'],
    studentKey: json['studentKey'],
    programKey: json['programKey'],
    studentName: json['studentName'],
    programType: ProgramTypeFromJSON(json['programType']),
    paymentDate: new Date(json['paymentDate']),
    amountPaid: CashAmountFromJSON(json['amountPaid']),
    description: json['description'],
    isDirectorDiscount: json['isDirectorDiscount'],
  }
}

export function TuitionPaymentInfoToJSON(
  value?: TuitionPaymentInfo | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    tuitionPaymentKey: value.tuitionPaymentKey,
    studentKey: value.studentKey,
    programKey: value.programKey,
    studentName: value.studentName,
    programType: ProgramTypeToJSON(value.programType),
    paymentDate: value.paymentDate.toISOString(),
    amountPaid: CashAmountToJSON(value.amountPaid),
    description: value.description,
    isDirectorDiscount: value.isDirectorDiscount,
  }
}
